<template>
  <div class="overlay">
    <article class="message is-link">
      <div class="message-header">
        <p>Session Expiring</p>
      </div>
      <div class="message-body warning-container">
        For security purposes, you will be logged out of Uniq-ID shortly due
        to inactivity in the application. Once you are logged out, all unsaved
        changes will be lost. Would you like to stay logged on ?
      </div>
      <footer class="modal-card-foot">
        <a class="button no-decoration" @click="expireSession">No, log me out</a>
        <button class="button is-primary" @click="keepMeLoggedIn">Yes, keep me logged in</button>
      </footer>
    </article>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'SessionExpiring',
  data() {
    return {
      logoffTimer: null,
    };
  },
  methods: {
    ...mapActions([
      'extendSession',
      'signOff',
    ]),
    async expireSession() {
      try {
        this.$store.state.user = null;
        localStorage.clear();
        await this.signOff();
      } catch (error) {
        console.log('could not signoff user!');
      }
      this.$router.push('/sessionExpired');
    },
    async keepMeLoggedIn() {
      try {
        await this.extendSession();
      } catch (error) {
        console.log('could not extend session!');
        this.$router.push('/sessionExpired');
      }
    },
  },
  mounted() {
    this.logoffTimer = setTimeout(() => {
      this.expireSession();
    }, 1000 * 60 * 1); // expire session if no response within a minute
  },
  beforeDestroy() {
    clearTimeout(this.logoffTimer);
  },
};
</script>

<style lang="sass">
.overlay
  position: fixed
  display: flex
  align-items: center
  justify-content: center
  top: 0
  right: 0
  bottom: 0
  left: 0
  margin: auto
  z-index: 999999
  background-color: rgba(0, 0, 0, 0.5)
.warning-container
  height: 100%
  width: 550px
  position: relative
  margin-top: 2.5rem
.no-decoration
  text-decoration: none
  &:hover
    text-decoration: none
</style>
